import React, { useEffect } from 'react'
import ListComments from '../Utils/ListComments'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { useParams } from 'react-router-dom'
import { getAllCommentsOfPostAPI, getPageCommentsSearch } from '../../RTK/Slice/Extract/ExtractPageSearchSlice'

const ExtractPageSearchComments = () => {

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Get User Token 
    const activeToken = useSelector(getActiveToken);

    // For Access Post Id 
    const {postId} = useParams() ; 

    // For Dispatch Action 
    const dispatch = useDispatch() ; 

    // For Access Data (comments , statusOfComments)
    const {comments ,statusOfComments } = useSelector(getPageCommentsSearch) ; 

    // For Get All Comments
    useEffect(()=>{
        dispatch(getAllCommentsOfPostAPI({token , userToken : activeToken , postId}))
    } , [dispatch , activeToken , token , postId])

  return (
    <div>
        <ListComments comments={comments} statusOfComments={statusOfComments} />
    </div>
  )
}

export default ExtractPageSearchComments
